import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../Pages/Tours.css'; 
import { BASE_IMG, getAllToursKir, formatDateTime } from '../../api';
import { useLang } from '../../redux/selectors';
import Footer from '../Footer';


const TourKirgiz = () => {
    const lang = useLang();
    const [tourKir, setTourKir] = useState([]); 

    useEffect(() => {
        getAllToursKir().then(({ data }) => {
            setTourKir(data);
        }).catch((error) => {
            console.error(error);
        })
    }, [])


    return (
        <main>
            <div className="top-back">
                <div className="content">
                    <h2>Киргизистан</h2>
                    <p>Главный / Туры / Киргизистан</p>
                </div>
            </div>
            <div className="tours-container">
                <h1 className="tours-header">Наши туры</h1>
                <div className="card-tours">
                    {tourKir.map(tour => (<Link to={`/tours/${tour.id}`} className="details-link">
                        <div className="tours-card" key={tour.id}>
                            <img src={BASE_IMG +tour.img} alt={tour.title_ru} />
                            <div className="card-content">
                                <div className="card-title">{tour[`title_${lang}`]}</div>
                                <div className="card-description">{formatDateTime(tour.created_at)}</div><br />
                            </div>
                        </div>
                    </Link>
                    ))}
                </div>
            </div>
            <Footer />
        </main>
    );
};

export default TourKirgiz;